
<template>
  <div>

    <v-row align="center" justify="end" class="px-3">
      <v-select class="mt-2" :rules="[ruleRequired('Campo obrigatório!'),]" v-model="one_schedule.frequency_option" :items="frequencies_options"
        label="Frequência" prepend-icon="mdi-calendar-refresh" item-value="value" item-text="text"
        @change="setFreqOpt()"
        color="secondary"
        item-color="secondary"
      ></v-select>

      <div class="text-right ml-5" v-if="one_schedule.frequency_option == 'custom'">
        <v-btn small color="secondary" v-if="one_schedule.frequency_option == 'custom'" @click="dialog_custom=true">Ver</v-btn>
      </div>
      <div class="text-right ml-5" v-if="one_schedule.frequency_option == 'exact_dates'">
        <v-btn small color="secondary" v-if="one_schedule.frequency_option == 'exact_dates'" @click="dialog_exact_dates=true">Ver</v-btn>
      </div>
    </v-row>

    <!-- <custom-frequency v-if="dialog_custom" ></custom-frequency> -->
    <v-dialog v-model="dialog_custom" scrollable  :fullscreen="isMobile"  persistent max-width="500px" transition="dialog-transition" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="title mb-0"> Frequência personalizada </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form lazy-validation ref='form_custom' v-model="valid_custom">
            <v-row align="center" class="mx-2">
              <div>
                Repetir a cada 
              </div>
              <v-col cols='4'>
                <v-text-field v-model="custom_frequency.repeat_at" color="secondary" :rules="[ruleRequired('Obrigatório'),ruleMaxInteger(90)]" prepend-icon="mdi-search" type='number' min='1'></v-text-field>
              </v-col>
              <v-col cols='4'>
                <v-select class="mt-2" v-model="custom_frequency.repeat_at_unit" color="secondary" item-color="secondary" :rules="[ruleRequired('Campo obrigatório!'),]" :items="repeat_at_units" item-text="text" item-value="value" ></v-select>
              </v-col>
            </v-row>
            <!-- WEEKDAYS -->
            <v-col v-if="custom_frequency.repeat_at_unit == 'week'">
              <div class="mb-2">Repetir:</div>
              <v-row>
                <!-- flat or icon are good to 1.5, fab or text are good to 2.0 -->
                <v-btn icon :class="['mx-2', custom_frequency.repeat_weekdays.includes('su')? 'secondary white--text' : '']" @click="setFrequency('su')">D</v-btn>
                <v-btn icon :class="['mx-2', custom_frequency.repeat_weekdays.includes('mo')? 'secondary white--text' : '']" @click="setFrequency('mo')">S</v-btn>
                <v-btn icon :class="['mx-2', custom_frequency.repeat_weekdays.includes('tu')? 'secondary white--text' : '']" @click="setFrequency('tu')">T</v-btn>
                <v-btn icon :class="['mx-2', custom_frequency.repeat_weekdays.includes('we')? 'secondary white--text' : '']" @click="setFrequency('we')">Q</v-btn>
                <v-btn icon :class="['mx-2', custom_frequency.repeat_weekdays.includes('th')? 'secondary white--text' : '']" @click="setFrequency('th')">Q</v-btn>
                <v-btn icon :class="['mx-2', custom_frequency.repeat_weekdays.includes('fr')? 'secondary white--text' : '']" @click="setFrequency('fr')">S</v-btn>
                <v-btn icon :class="['mx-2', custom_frequency.repeat_weekdays.includes('sa')? 'secondary white--text' : '']" @click="setFrequency('sa')">S</v-btn>
              </v-row>
              <div v-if="!valid_custom && !custom_frequency.repeat_weekdays.length" class="error--text pt-3">Informação necessária</div>
            </v-col>
            <v-col v-if="custom_frequency.repeat_at_unit == 'month'" class="pt-0 text-center pr-0">
              <!-- <div class="black--text">Sempre no dia {{`${new Date().toLocaleDateString('pt-BR', {day: 'numeric'})}`}}</div> -->
              <div class="black--text">Sempre no dia {{`${new Date(`${one_schedule.start_date}T12:00:00`).toLocaleDateString('pt-BR', {day: 'numeric'})}`}}</div>
              <!-- <div class="black--text">Sempre no dia {{custom_frequency.day[0]}}</div> -->
            </v-col>
            <v-col v-if="custom_frequency.repeat_at_unit == 'year'" class="pt-0 text-center pr-0">
              <div>Sempre no dia {{`${new Date(`${one_schedule.start_date}T12:00:00`).toLocaleDateString('pt-BR', {month: 'long', day: 'numeric'})}`}}</div>
              <!-- <div class="black--text">Sempre no dia {{custom_frequency.day[0]}}</div> -->
            </v-col>

            <!-- END AT -->
            <v-col>
              <div>Termina em: </div>
              <v-col>
                <v-radio-group v-model="custom_frequency.end_kind" column mandatory dense>
                  <v-radio value="never_ends" class="pb-0">
                    <template v-slot:label>
                      <div>Nunca</div>
                    </template>
                  </v-radio>
                  <v-row align="center">
                    <v-col cols='3' class="py-0">
                      <v-radio value="date">
                        <template v-slot:label>
                          <div>Em</div>
                        </template>
                      </v-radio>
                    </v-col>
                    <v-col cols='6' class="py-0 pt-4" v-if="custom_frequency.end_kind == 'date'">
                      <when-selector
                        v-model="custom_frequency.end_at"
                        :inital_date="custom_frequency.end_at"
                        :rules="[ruleRequired('Campo obrigatório!')]"
                        text=""
                        :disabled="custom_frequency.end_kind != 'date'"
                        min_is_today
                        :outlined="false"
                        :filled="true"
                        dense
                        :hide-details="true"
                      ></when-selector>
                      <!-- <v-text-field v-model="custom_frequency.end_at" filled dense prepend-icon="mdi-search" ></v-text-field> -->
                    </v-col>
                  </v-row>
                  <v-row align="center">
                    <v-col cols='3' class="py-0">
                      <v-radio label="Após" value="repetitions"></v-radio>
                    </v-col>
                    <v-col cols='9' sm='6' class="py-0" v-if="custom_frequency.end_kind == 'repetitions'">
                      <v-text-field v-model="custom_frequency.end_after_repetitions" color="secondary" hide-details :rules="[ruleRequired(''),]" :disabled="custom_frequency.end_kind != 'repetitions'" filled dense type='number' min='2' suffix="ocorrências"></v-text-field>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-col>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn text small color="error" @click="closeDialogCustom">Cancelar</v-btn>
          <v-btn small color="secondary" @click="saveDialogCustom">concluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_exact_dates"
      scrollable  :fullscreen="isMobile"  persistent max-width="650px" transition="dialog-transition"
    >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Selecionar datas</div>
        </v-card-title>
        <v-card-text>
          <v-row justify="center" class="pa-3">
            <vc-calendar 
              timezone="UTC" 
              :is-dark="$vuetify.theme.isDark"
              :color="'purple'"
              :rows="1"
              :columns="$screens({ default: 1, sm: 2, md: 3, lg: 2 })" 
              @dayfocusin="onDayClick"
              :attributes="calendar_attributes"
              :min-date="new Date()"
            >
              <!-- @dayclick="onDayClick"  -->
            </vc-calendar>

          </v-row>
          <div>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn small text color="error" @click="closeDialogExactDates">Cancelar</v-btn>
          <v-btn small color="secondary" @click="saveDialogExactDates">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import responsive from "@/mixins/responsive";
import validations from "@/mixins/validations";

export default {
  name: 'SelectFrequency',
  mixins: [responsive, validations],
  props: {
    one_schedule: {
      type: Object,
    },
  },
  components: {
    // CustomFrequency: () => import('./CustomFrequency.vue'),
    WhenSelector: () => import("@/components/imports/_date_picker_01.vue"),
  },
  data() {
    return {
      dialog_custom: false,
      custom_frequency: {},
      valid_custom: true,
      frequencies_options: [
        {
          text: 'Não se repete',
          action: () => {},
          value: 'never',
          settings: {
            repeat_at: null,
            repeat_at_unit: 'month', //'day' 'week' 'month' 'year'

            repeat_weekdays: [], 
            
            day: [],
            month:  [],

            end_kind: 'repetitions', // ['nunca', 'em', 'após'],
            end_at: null, // date
            end_after_repetitions: 1, //integer
          },
        },
        {
          text: 'Todos os dias',
          action: () => {},
          value: 'everey_day',
          settings: {
            repeat_at: null,
            repeat_at_unit: 'day', //'day' 'week' 'month' 'year'

            repeat_weekdays: ['su','mo', 'tu','we','th','fr','sa'], 
            
            day: [],
            month: [],
            
            end_kind: null, // ['nunca', 'em', 'após'],
            end_at: null, // date
            end_after_repetitions: null, //integer
          },
        },
        {
          text: `Semanal: cada ${new Date().toLocaleDateString('pt-BR', {weekday: 'long'})}`,
          action: () => {},
          value: 'weekly_on',
          settings:  {
            repeat_at: null,
            repeat_at_unit: 'day', //'day' 'week' 'month' 'year'

            repeat_weekdays: [new Date().toLocaleDateString('en-US', {weekday: 'long'}).substring(0,2).toLowerCase()], 

            day: [],
            month: [],
            
            end_kind: null, // ['nunca', 'em', 'após'],
            end_at: null, // date
            end_after_repetitions: null, //integer
          },
        },
        // {
        //   text: `Mensal: no(a) primeiro(a) ${new Date().toLocaleDateString('pt-BR', {weekday: 'long'})}`,
        //   action: () => {},
        //   settings: null,
        // },
        {
          text: `Mensal: no dia ${new Date().toLocaleDateString('pt-BR', {day: 'numeric'})}`,
          action: () => {},
          value: 'every_month',
          settings:  {
            repeat_at: null,
            repeat_at_unit: 'month', //'day' 'week' 'month' 'year'

            repeat_weekdays: null,

            day: [new Date().toLocaleDateString('pt-BR', {day: 'numeric'})],
            month: [1,2,3,4,5,6,7,8,9,10,11,12],
            
            end_kind: null, // ['nunca', 'em', 'após'],
            end_at: null, // date
            end_after_repetitions: null, //integer
          },
        },
        {
          text: `Anual: em ${new Date().toLocaleDateString('pt-BR', {month: 'long', day: 'numeric'})}`,
          action: () => {},
          value: 'every_year',
          settings:  {
            repeat_at: null,
            repeat_at_unit: 'year', //'day' 'week' 'month' 'year'

            repeat_weekdays: null,

            day: [new Date().toLocaleDateString('pt-BR', {day: 'numeric'})],
            month: [new Date().toLocaleDateString('pt-BR', {month: 'numeric'})],

            end_kind: null, // ['nunca', 'em', 'após'],
            end_at: null, // date
            end_after_repetitions: null, //integer
          },
        },
        {
          text: 'Todos os dias da semana (segunda a sexta-feira)',
          action: () => {},
          value: 'all_weekdays',
          settings: {
            repeat_at: null,
            repeat_at_unit: 'day', //'day' 'week' 'month' 'year'

            repeat_weekdays: ['mo', 'tu','we','th','fr'], 

            day: [],
            month: [],

            end_kind: null, // ['nunca', 'em', 'após'],
            end_at: null, // date
            end_after_repetitions: null, //integer
          },
        },
        {
          text: 'Selecionar dias',
          action: () => {this.dialog_exact_dates = true},
          value: 'exact_dates',
          settings: {
            repeat_at: null,
            repeat_at_unit: 'never_repeat', //'day' 'week' 'month' 'year'
            
            repeat_weekdays: [], 

            day: [],
            month: [],

            end_kind: null, // ['nunca', 'em', 'após'],
            end_at: null, // date
            end_after_repetitions: null, //integer
          },
        },
        {
          text: 'Personalizar...',
          action: () => {this.dialog_custom = true},
          value: 'custom',
          settings: {
            repeat_at: null,
            repeat_at_unit: 'week', //'day' 'week' 'month' 'year'
            
            repeat_weekdays: [], 

            day: [new Date().toLocaleDateString('pt-BR', {day: 'numeric'})],
            month: [new Date().toLocaleDateString('pt-BR', {month: 'numeric'})],

            end_kind: null, // ['nunca', 'em', 'após'],
            end_at: null, // date
            end_after_repetitions: null, //integer
          },
        },
      ],
      repeat_at_units: [
        {
          text: 'dia(s)',
          value: 'day',
        },
        {
          text: 'semana(s)',
          value: 'week',
        },
        // {
        //   text: 'quinzenal',
        //   value: 'biweek',
        // },
        {
          text: 'mês(es)',
          value: 'month',
        },
        {
          text: 'ano(s)',
          value: 'year',
        },
      ],

      dialog_exact_dates: false,
      exact_dates: [],
      ready: true,

    }
  },
  methods: {
    onDayClick(day){
      const idx = this.exact_dates.findIndex(d => this.$moment(d).format() == this.$moment(day.date).format());
      if (idx >= 0) {
        this.exact_dates.splice(idx, 1);
      } else {
        const today = this.$moment().startOf('day')
        const diff_date = this.$moment(day.date).add("12", "hours").diff(today)
        // console.log({today, diff_date});
        if (diff_date >= 0) {
          this.exact_dates.push(day.date)
        }
        // this.exact_dates.push({
        //   id: day.id,
        //   date: day.date,
        // });

      }
      // console.log({day}, day.date, this.exact_dates);

    },
    closeDialogExactDates(){
      this.exact_dates = []
      this.dialog_exact_dates = false
    },
    saveDialogExactDates(){
      this.$emit('doneExact', this.exact_dates)
      this.dialog_exact_dates = false
    },
    setFreqOpt(){
      let selected = this.frequencies_options.find(fo => fo.value == this.one_schedule.frequency_option)
      if (selected){
        selected.action()
        this.$emit('doneFreqSelect', selected.settings)
      }
    },
    updateOptions(val){
      val = val || this.one_schedule.start_date
      // console.log({val});
      val= val+'T12:00:00'
      this.frequencies_options = this.frequencies_options.map((fo, idx) => {
        let n_day = new Date(val).toLocaleDateString('pt-BR', {day: 'numeric'})
        let n_month_num = new Date(val).toLocaleDateString('pt-BR', {month: 'numeric'})
        // let n_month_long = new Date(val).toLocaleDateString('pt-BR', {month: 'long'})
        let n_wd_long = new Date(val).toLocaleDateString('pt-BR', {weekday: 'long'})

        let {settings: {day, month, ...s}, text, value, ...f } = fo 
        // console.log({s});
        // console.log({f});
        if (idx > 1){
          if (idx == 2){
            text = `Semanal: cada ${n_wd_long}`
            s.repeat_weekdays = [new Date(val).toLocaleDateString('en-US', {weekday: 'long'}).substring(0,2).toLowerCase()]
          }
          if (idx == 3){
            text = `Mensal: no dia ${n_day}`
            day = [n_day]
          }
          if (idx == 4){
            text = `Anual: em ${new Date(val).toLocaleDateString('pt-BR', {month: 'long', day: 'numeric'})}`
            day = [n_day]
            month = [n_month_num]
          }
          if (idx == 6){
            day = [n_day]
            month = [n_month_num]
          }
          if (value =='custom'){
            s = {...this.one_schedule.custom_frequency}
            day = [...this.one_schedule.custom_frequency.day]
            month = [...this.one_schedule.custom_frequency.month]
          }
          let obj = {
            ...f,
            text,
            value,
            settings: {
              ...s, 
              day, month,
            }
          }
          // console.log({obj});
          if (this.one_schedule.frequency_option == 'custom' && value == 'custom'){
            this.$emit('doneCustom', obj.settings)
          } else if (this.one_schedule.frequency_option == value){
            this.$emit('doneFreqSelect', obj.settings)
          }

          return {...obj}
        } else {
          return {...fo}
        }
      })
    },
    setFrequency(data){
      if (this.custom_frequency.repeat_weekdays.includes(data)){
        let idx = this.custom_frequency.repeat_weekdays.indexOf(data)
        this.custom_frequency.repeat_weekdays.splice(idx, 1)
      } else {
        this.custom_frequency.repeat_weekdays.push(data)
      }
    },
    closeDialogCustom() {
      if (!(this.$refs.form_custom.validate() && (this.custom_frequency.repeat_at_unit != 'week' || this.custom_frequency.repeat_at_unit == 'week' && this.custom_frequency.repeat_weekdays.length))){
        this.one_schedule.frequency_option = null
      }
      this.custom_frequency = {...this.one_schedule.custom_frequency}
      this.dialog_custom = false
    },
    saveDialogCustom(){
      if (this.$refs.form_custom.validate() && (this.custom_frequency.repeat_at_unit != 'week' || this.custom_frequency.repeat_at_unit == 'week' && this.custom_frequency.repeat_weekdays.length)){
        this.$emit('doneCustom', this.custom_frequency)
        this.dialog_custom = false
      } else {
        this.valid_custom = false
      }
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted() {
    this.updateOptions()
  },
  computed: {
    calendar_attributes() {
      return this.exact_dates.map(date => ({
        highlight: true,
        dates: date,
      }));
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog_exact_dates(nv,ov) {
      if (nv && this.one_schedule.exact_dates){
        this.exact_dates = this.one_schedule.exact_dates.map(ed => this.$moment(ed).toDate())
      } else if (nv == false){
        
      }
    },
    dialog_custom(nv,ov) {
      if (nv){
        this.custom_frequency = {...this.one_schedule.custom_frequency}
      } else if (nv == false){
        this.custom_frequency = {}
      }
    },
    'custom_frequency.repeat_at_unit'(nv,ov) {
      if (nv != 'week'){
        this.custom_frequency.repeat_weekdays = []
        
      } else if (nv){
      }
    },
    'one_schedule.start_date'(nv,ov) {
      if (nv){
        this.updateOptions(nv)
      } else if (nv == false){
    
      }
    },
    'one_schedule.frequency_option'(nv,ov) {
      if (nv){
        // let selected = this.frequencies_options.find(fo => fo.value == nv)
        // selected.action()
        // this.$emit('doneFreqSelect', selected.settings)
        // nv.action()
      } else if (nv == false){
    
      }
    },
  },
}
</script>

<style scoped>

</style>